import utils from '../../../modules/utils';
import API from '../../api/api';
import Track from '../../utils/tracking';

function isTokenReceived(status) {
  // Method UNSUPPORTED
  return false;
}

function isReturningFromHostedPage(queryParams) {
  return !!utils.fn.getURIParam(queryParams, 'code');
}

function returnedFromHostedPage(queryParams) {
  return API.handleWeChatAuthorizationUpdate(utils.fn.getURIParam(queryParams, 'code'));
}

const processWeChatPaymentRequest = orderJSON => new Promise((resolve, reject) => {
  const weChatData = orderJSON.paymentMethodAttributes;
  
  /**
     * NOTE -> WeixinJSBridge will be undefined in ALL environments except
     * the Weixin browser. The code is injected in by the application
     * and is native to their platform.
     */
  if (typeof window.WeixinJSBridge !== 'undefined') {
    window.WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        appId: weChatData.appId,
        timeStamp: weChatData.timestamp,
        nonceStr: weChatData.nonce,
        package: weChatData.prepayId,
        signType: weChatData.signType,
        paySign: weChatData.signature,
      },
      (response) => {
        switch (response.err_msg) {
          case 'get_brand_wcpay_request:ok':
            API.handleWeChatSessionUpdate('paymentSuccess')
              .then(resolve)
              .catch(reject);
            break;
          case 'get_brand_wcpay_request:fail':
            Track.error(new Error(`getBrandWCPayRequest returned fail response: ${JSON.stringify(response)}`));
            API.handleWeChatSessionUpdate('paymentFailure')
              .finally(reject);
            break;
          case 'get_brand_wcpay_request:cancel':
            API.handleWeChatSessionUpdate('cancelled')
              .finally(reject);
            break;
          default:
            Track.error(new Error(`getBrandWCPayRequest returned bad response: ${JSON.stringify(response)}`));
            reject();
            break;
        }
      },
    );
  } else {
    Track.error(new Error('WeixinJSBridge is undefined for WeChat payment'));
    reject();
  }
});

export default {
  isTokenReceived,
  isReturningFromHostedPage,
  returnedFromHostedPage,
  processWeChatPaymentRequest,
};
